<template lang="pug">
.v-section-bottom-slider.section-bottom-slider(v-if="slider" )
	v-loader(:loading="loading")
	.section-bottom-slider__buttons
		button.section-bottom-slider__button.slider-btn.left(ref="prev")
		button.section-bottom-slider__button.slider-btn.right(ref="next")
	v-swiper-slider(v-if="slider.items && slider.items.length"
		:options="options"
		:navigation="navigation"
		@swiper="onSwiper")
		swiper-slide.section-slider__slide(v-for="(item, index) in slider.items" :key="index")
			v-section-bottom(:data-source="item" )
</template>

<script>
import breakpoints from '../scripts/breakpoints.js';
import uniqueId from '../scripts/helpers/uniqueId.js';
import {SwiperSlide} from "swiper/vue";

export default {
	components: {
		SwiperSlide,
	},

	props: {
		slider: {
			type: Object,
			default: null
		},
	},


	data() {
		return {
			loading: false,
			uniqueId: uniqueId('swiper-'),
			options: {
				slidesPerView: 1,
				effect: "fade",
				fade: { crossFade: true },
				a11y: {
					prevSlideMessage: 'Предыдущий слайд',
					nextSlideMessage: 'Следующий слайд',
				},
				breakpoints: {
					[breakpoints['lg-min']]: {
						slidesPerView: 1
					},
				}
			},
			navigation: false
		};
	},

	methods: {
		onSwiper(e) {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},
	}

};
</script>